import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=f7957578&scoped=true&"
import script from "./Character.vue?vue&type=script&lang=js&"
export * from "./Character.vue?vue&type=script&lang=js&"
import style0 from "./Character.vue?vue&type=style&index=0&id=f7957578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7957578",
  null
  
)

export default component.exports